// extracted by css-extract-rspack-plugin
export default {"sources":"RoleSources_sources__j+xaF","step":"RoleSources_step__1jr5J"};